import { render } from "./VideoCanvas.vue?vue&type=template&id=2e646055&scoped=true"
import script from "./VideoCanvas.vue?vue&type=script&lang=js"
export * from "./VideoCanvas.vue?vue&type=script&lang=js"

import "./VideoCanvas.vue?vue&type=style&index=0&id=2e646055&scoped=true&lang=css"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e646055"]])

export default __exports__